.now-line {
  position: absolute;
  z-index: 2;
  right: 0;
  height: 1px;
  background: var(--rc-calendar-now-line-color);
  pointer-events: none;

  &.week-mode {
    background: transparent;
  }

  .segments {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    height: 100%;
  }

  .segment-solid {
    height: 100%;
    background: var(--rc-calendar-now-line-color);
  }

  .segment-dashed {
    height: 100%;
    background-image: repeating-linear-gradient(
      to right,
      transparent 0 4px,
      var(--rc-calendar-now-line-color) 4px 10px
    );
  }

  .now-dot {
    position: absolute;
    top: -3.5px;
    left: -3.5px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: var(--rc-calendar-now-line-color);
  }
}
